<template>
  <div class="common-box user-console">
    <div class="button-box">
      <div class="button">
        <img src="static/images/zbdt.png" alt="" />
        <p>
          <span class="name">在保电梯(台)</span>
          <span class="num normal">{{
            totalStatistics.guaranteeLiftAmount
          }}</span>
        </p>
      </div>
      <div class="button">
        <img src="static/images/sydw.png" alt="" />
        <p>
          <span class="name">使用个数(个)</span>
          <span class="num normal">{{
            totalStatistics.propertyUnitAmount
          }}</span>
        </p>
      </div>
      <div class="button">
        <img src="static/images/xmsl.png" alt="" />
        <p>
          <span class="name">项目数量(个)</span>
          <span class="num normal">{{ totalStatistics.projectAmount }}</span>
        </p>
      </div>
      <div class="button">
        <img src="static/images/yggs.png" alt="" />
        <p>
          <span class="name">员工个数(个)</span>
          <span class="num normal">{{ totalStatistics.employeeAmount }}</span>
        </p>
      </div>
      <div class="button">
        <img src="static/images/jrby.png" alt="" />
        <p>
          <span class="name">今日保养(台)</span>
          <span class="num normal">{{
            totalStatistics.todayMaintainAmount
          }}</span>
        </p>
      </div>
      <div class="button">
        <img src="static/images/jrwx.png" alt="" />
        <p>
          <span class="name">今日维修(台)</span>
          <span class="num normal">{{
            totalStatistics.todayRepairAmount
          }}</span>
        </p>
      </div>
      <div class="button" v-if="false">
        <img src="static/images/jrxc.png" alt="" />
        <p>
          <span class="name">今日巡查(台)</span>
          <span class="num normal">{{ totalStatistics.employeeAmount }}</span>
        </p>
      </div>
      <div class="button" v-if="false">
        <img src="static/images/zdgz.png" alt="" />
        <p>
          <span class="name">重点关注(台)</span>
          <span class="num normal">{{ totalStatistics.employeeAmount }}</span>
        </p>
      </div>
      <div class="button canClick" @click.stop="getCheck(3)">
        <img src="static/images/jjnj.png" alt="" />
        <p>
          <span class="name">年检即将到期(台)</span>
          <span class="num normal">{{
            totalStatistics.inspectionComingOverdueAmount
          }}</span>
        </p>
      </div>
      <div class="button canClick" @click.stop="getCheck(4)">
        <img src="static/images/njcq.png" alt="" />
        <p>
          <span class="name">年检已经到期(台)</span>
          <span class="num normal">{{
            totalStatistics.inspectionAlreadyOverdueAmount
          }}</span>
        </p>
      </div>
      <div class="button canClick" @click.stop="getBeyond(1)">
        <img src="static/images/htjjdq.png" alt="" />
        <p>
          <span class="name">超期未保(台)</span>
          <span class="num normal">{{
            totalStatistics.todayOverdueAmount
          }}</span>
        </p>
      </div>
      <div class="button canClick" @click.stop="getBeyond(2)">
        <img src="static/images/zdgz.png" alt="" />
        <p>
          <span class="name">超期未完成(台)</span>
          <span class="num normal">{{
            totalStatistics.todayOverdueNotFinishAmount
          }}</span>
        </p>
      </div>
      <div class="button" v-if="false">
        <img src="static/images/xsqxj.png" alt="" />
        <p>
          <span class="name">限速器校检(台)</span>
          <span class="num normal">{{ totalStatistics.employeeAmount }}</span>
        </p>
      </div>

      <div class="button canClick" @click="getContract(1)">
        <img src="static/images/htjjdq.png" alt="" />
        <p>
          <span class="name">合同即将到期(个)</span>
          <span class="num normal">{{
            totalStatistics.financialComingOverdueAmount
          }}</span>
        </p>
      </div>
      <div class="button canClick" @click="getContract(2)">
        <img src="static/images/zdgz.png" alt="" />
        <p>
          <span class="name">合同已到期(个)</span>
          <span class="num normal">{{
            totalStatistics.financialOverdueAmount
          }}</span>
        </p>
      </div>
      <div class="button canClick" @click="goInsurance(5)">
        <img src="static/images/htjjdq.png" alt="" />
        <p>
          <span class="name">保险即将到期</span>
          <span class="num normal">{{ totalStatistics.insuranceComingOverdueAmount }}</span>
        </p>
      </div>
      <div class="button canClick" @click="goInsurance(6)">
        <img src="static/images/zdgz.png" alt=""  />
        <p>
          <span class="name">保险已经到期</span>
          <span class="num normal">{{ totalStatistics.insuranceOverdueAmount }}</span>
        </p>
      </div>
    </div>
    <div class="user-console-main">
      <div class="user-console-main-left">
        <ranking></ranking>
      </div>
      <div class="user-console-main-right">
        <maintenance-calendar></maintenance-calendar>
      </div>
    </div>
    <Beyond
      :getDetailParams="getBeyondParams"
      v-if="showBeyond"
      @cancel="showBeyond = false"
    />
    <Check
      :getDetailParams="getCheckParams"
      v-if="showCheck"
      @cancel="showCheck = false"
    />
    <Contract
      :getDetailParams="getContractParams"
      v-if="showContract"
      @cancel="showContract = false"
    />
    <Insurance 
      :getDetailParams="getInsuranceParams"
      v-if="showInsurance"
      @cancel="showInsurance = false"
    />
  </div>
</template>

<script>
import MaintenanceCalendar from "./components/MaintenanceCalendar.vue";
import { getTotalStatistics } from "@/api/UserConsole";
import Ranking from "./components/Ranking.vue";
// 维保超期
import Beyond from "./components/Beyond";
// 年检超期
import Check from "./components/Check";
// 合同到期
import Contract from "./components/Contract";

// 保险
import Insurance from './components/Insurance';
export default {
  name: "UserConsole",
  components: {
    MaintenanceCalendar,
    Ranking,
    Check,
    Beyond,
    Contract,
    Insurance
  },
  data() {
    return {
      totalStatistics: {
        employeeAmount: "", //员工总数
        guaranteeLiftAmount: "", //在保电梯总数
        projectAmount: "", //项目数量
        propertyUnitAmount: "", //使用单位数量
        todayMaintainAmount: "", //今日维保总数
        todayOverdueAmount: "", //今日超期总数
        todayRepairAmount: "", //今日维修总数
        inspectionAlreadyOverdueAmount: "", //年检 已经到期
        inspectionComingOverdueAmount: "", //年检 即将到期
        todayOverdueNotFinishAmount: "", //超期未完成
        todayOverdueAmount: "", //超期未保
      },
      showBeyond: false,
      showCheck: false,
      showContract: false,
      showInsurance: false,
      getBeyondParams: {},
      getCheckParams: {},
      getContractParams: {},
      getInsuranceParams: {}
    };
  },
  created() {
    this.getTotalStatistics();
  },
  methods: {
    async getTotalStatistics() {
      const res = await getTotalStatistics();
      if (res.code === 200) {
        this.totalStatistics = res.data;
      }
    },
    getBeyond(val) {
      this.getBeyondParams.statisticType = val;
      this.showBeyond = true;
    },
    getCheck(val) {
      this.getCheckParams.statisticType = val;
      this.showCheck = true;
    },
    getContract(val) {
      this.getContractParams.statisticType = val;
      this.showContract = true;
    },
    goInsurance(val) {
      this.getInsuranceParams.statisticType = val;
      this.showInsurance = true;
    }
  },
};
</script>

<style lang="scss">
.user-console {
  position: absolute;
  left: 20px;
  right: 0px;
  top: 20px;
  bottom: 20px;
  display: block;
  overflow-y: auto;
  background-color: #efefef;
  padding-bottom: 20px;
  .button-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    .canClick {
      cursor: pointer;
    }
    .button {
      margin-right: 20px;
      margin-bottom: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      background-color: #ffffff;
      width: 260px;
      height: 90px;
      border-radius: 4px;
      box-shadow: 0 2px 5px 0 rgba(198, 198, 198, 0.5);
      p {
        display: flex;
        flex-direction: column;
      }
      img {
        display: block;
        width: 50px;
        height: 50px;
        border-radius: 4px;
        margin-left: 30px;
        margin-right: 10px;
      }
      .name {
        font-size: 14px;
        color: #666666;
      }
      .num {
        font-size: 24px;
      }
      .normal {
        color: #3bcacd;
      }
      .yellow {
        color: #ffa422;
      }
      .red {
        color: #f84770;
      }
      .purple {
        color: #9c81ff;
      }
    }
  }
  .user-console-main {
    display: flex;
    .user-console-main-left {
      width: 540px;
      border-radius: 4px;
      overflow: hidden;
      background-color: #ffffff;
      overflow-y: auto;
      box-shadow: 0 2px 5px 0 rgba(198, 198, 198, 0.5);
    }
    .user-console-main-right {
      flex: 1;
      overflow-y: auto;
      margin-right: 14px;
      border-radius: 4px;
      margin-left: 20px;
      box-shadow: 0 2px 5px 0 rgba(198, 198, 198, 0.5);
    }
  }
  .common-h5 {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #333333;
    font-weight: normal;
    position: relative;
    &::before {
      content: " ";
      height: 14px;
      width: 4px;
      position: absolute;
      top: 4px;
      left: -8px;
      background-color: #0092ff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/UserConsole/UserConsole.vue